module.exports = require("mjml");